package com.appcreator.blueprint.firebase.messaging

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("FirebaseMessagingSetTopicsAction")
@ActionClass(
    group = FirebaseMessagingConsts.group,
    title = "Set topics",
    isExtraPlugin = true,
    availableFrom = "0.0.1"
)
class FirebaseMessagingSetTopicsAction(
    @InputProperty(
        title = "Prefix",
        description = "Prefix for unsubscribing, topics not matched will be kept",
        availableFrom = "0.0.1"
    )
    val prefix: String?,

    @InputProperty(
        title = "Topics",
        description = "Comma separated list of topics, topics not in the list will be unsubscribed from",
        availableFrom = "0.0.1"
    )
    val topics: String?,
): Action
